import { injectGlobal } from 'styled-components';

injectGlobal`
.tooltip {
  position: relative;
  z-index: 9999;
  backface-visibility: hidden;
  &::before {
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    position: absolute;
    background-color: #2B222A;
    border-radius: 5px;
    color: #fff;
    content: attr(alt);
    text-transform: none;
    transition: all 0.5s ease;
    padding: 0px 5px 0px 5px;
    min-width: 25px;
    white-space: nowrap;
    backface-visibility: hidden;
  }
  &::after {
    transition: all 0.5s ease;
    border: solid;
    border-color: #2B222A transparent;
    border-width: 6px 6px 0 6px;
    bottom: 24px;
    content:"";
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    backface-visibility: hidden;
  }
  &::before,
  &::after {
    color: #efefef;
    font-size: 12px;
    opacity: 0;
    pointer-events: none;
    text-align: center;
  }
  &:focus::after,
  &:hover::after {
    opacity: 1;
    transition: all 0.75s ease;
  }
  &:focus::before,
  &:hover::before {
    opacity: 1;
    transition: all 0.75s ease;
  }
}
.tooltip_altered {
  position: relative;
  z-index: 3;
  backface-visibility: hidden;
  &::before {
    left: 50%;
    bottom: 36px;
    transform: translateX(-50%);
    position: absolute;
    background-color: #2B222A;
    border-radius: 5px;
    color: #fff;
    content: attr(alt);
    text-transform: none;
    transition: all 0.5s ease;
    padding: 0px 5px 0px 5px;
    min-width: 25px;
    white-space: nowrap;
    backface-visibility: hidden;
  }
  &::after {
    transition: all 0.5s ease;
    border: solid;
    border-color: #2B222A transparent;
    border-width: 6px 6px 0 6px;
    bottom: 30px;
    content:"";
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    backface-visibility: hidden;
  }
  &::before,
  &::after {
    color: #efefef;
    font-size: 12px;
    opacity: 0;
    pointer-events: none;
    text-align: center;
  }
  &:focus::after,
  &:hover::after {
    opacity: 1;
    transition: all 0.75s ease;
  }
  &:focus::before,
  &:hover::before {
    opacity: 1;
    transition: all 0.75s ease;
  }
}
`;



// WEBPACK FOOTER //
// ./src/components/ToolTip/styles.js